<template>
  <div v-if="!isEmptyProduct">
    <CartSetManyMealsProduct
      v-for="(product, index) in setProducts"
      :index="index"
      :key="product.id"
      :product="product"
      :onChecked="checkingCartItem"
      :onDelete="removeToCartItem"
      :onAddQuantity="addQuantityToCartItem"
      :onSubQuantity="subQuantityToCartItem"
      :onMoveDetail="moveProductDetail"
      :onMoveFirstPurchase="onMoveFirstPurchase"
    />
  </div>
</template>

<script>
import Cart from '@/models/Cart/Cart'
import Product from '@/models/Product/Product'

import CartSetManyMealsProduct from '@/presentationals/v2/components/layouts/organisms/CartSetManyMealsProduct'
import { Location, MoveType } from '@/plugins/AppManager'
import { LogScreenName, LogType, LogGroup, LogEvent } from '@/plugins/AppLogManager'

import { NewCustomerProductEvent } from '../../../../../config/eventProvider'

export default {
  name: 'CartSetManyMealsProductsContainer',
  components: {
    CartSetManyMealsProduct
  },
  methods: {
    checkingCartItem(product, index) {
      product.select(!product.getChecked())
    },

    moveProductDetailLog(product) {
      const params = {
        ItemStatus: product.isPurchasable() ? 'PURCHASEABLE' : 'UNPURCHASEABLE',
        ProductId: String(product.getId()),
        SelectedItem: product.getItems().map(item => ({ ItemId: String(item.getId()) })),
        ShopNo: this.$store.getters['baeminShopNo']
      }

      // M1-1
      this.$appLogManager.post({
        screenName: LogScreenName.MARKET_CART,
        type: LogType.CLICK,
        group: LogGroup.PRODUCT_DET,
        event: LogEvent.PRODUCT_DET,
        params
      })
    },

    moveProductDetail(product) {
      // 교환 반품 상품
      if (product.getReturnOrExchange()) return
      // 상품 준비중
      if (product.getDisabled()) return

      this.moveProductDetailLog(product)

      this.$appManager.move(Location.PRODUCT, this.$store.getters.isAndroid, MoveType.REPLACE, {
        marketProduct_ref: 'Cart',
        market_shopNo: product.getBaeminShopNo(),
        marketProduct_shopNo: product.getBaeminShopNo(),
        marketProduct_productId: product.getId()
      })
      // const url = `${this.$deepLinkProtocol}./marketProduct?marketProduct_ref=Cart&marketProduct_shopNo=${product.baeminShopNo}&marketProduct_productId=${product.productId}`
      // window.location.replace(url)
    },

    removeToCartItemLog(product) {
      const params = {
        ItemStatus: product.isPurchasable() ? 'PURCHASEABLE' : 'UNPURCHASEABLE',
        ProductId: String(product.getId()),
        SelectedItem: product.getItems().map(item => ({ ItemId: String(item.getId()) })),
        ShopNo: this.$store.getters['baeminShopNo']
      }

      // M1-2
      this.$appLogManager.post({
        screenName: LogScreenName.MARKET_CART,
        type: LogType.CLICK,
        group: LogGroup.PRODUCT_DET,
        event: LogEvent.DELETE,
        params
      })
    },

    async removeToCartItem(product, index) {
      const result = await this.$store.dispatch('cart/removeProducts', [product])

      if (!result) return
      this.$store.commit('cart/removeProduct', product.getId())
      this.removeToCartItemLog(product)
    },

    async modifyQuantity(product, value) {
      const newProduct = new Product({
        productId: product.getId(),
        items: product.getItems()
      })

      const params = {
        product: newProduct,
        value
      }

      const result = await this.$store.dispatch('cart/modifyQuantity', params)
      return result
    },

    quantityToCartItemLog(product, isPlus = true) {
      const params = {
        ItemQtyAdjust: isPlus,
        ProductId: String(product.getId()),
        SelectedItem: product.getItems().map(item => ({ ItemId: String(item.getId()) })),
        ShopNo: this.$store.getters['baeminShopNo']
      }

      // M1-5
      this.$appLogManager.post({
        screenName: LogScreenName.MARKET_CART,
        type: LogType.CLICK,
        group: LogGroup.PRODUCT_DET,
        event: LogEvent.QTY,
        params
      })
    },

    async addQuantityToCartItem(product, index) {
      if (product.getQuantity() >= product.getMaxCount()) return
      if (product.getQuantity() >= product.getStockCount()) return
      if (product.getQuantity() >= product.getStockCount() && product.getChecked()) {
        product.select(false)
      }

      const flag = await this.modifyQuantity(product, 1)
      if (!flag) return

      product.addQuantity()

      const targetOptions = product.getOptions()

      targetOptions.forEach(target => {
        target.checkIntersectQuantity(product.getQuantity())
        target.addQuantity(product.getQuantity())
      })

      this.quantityToCartItemLog(product)
    },

    async subQuantityToCartItem(product, index) {
      if (product.getQuantity() <= product.getMinCount()) return

      const flag = await this.modifyQuantity(product, -1)
      if (!flag) return

      product.subQuantity()

      const targetOptions = product.getOptions()

      targetOptions.forEach(target => {
        target.checkIntersectQuantity(product.getQuantity())
        target.subQuantity(product.getQuantity())
      })

      if (product.getLocked() === true && product.getQuantity() <= product.getStockCount()) {
        product.setLocked(false)
        product.select(true)
      }

      this.quantityToCartItemLog(product, false)
    },

    onMoveFirstPurchase() {
      window.location = `${process.env.VUE_APP_DEEP_LINK_PROTOCOL}./marketFirstCatalog?marketFirstCatalog_catalogId=${NewCustomerProductEvent.catalogId}&marketFirstCatalog_ref=CART`
    }
  },
  computed: {
    isEmptyProduct() {
      return !this.setProducts
    },
    setProducts() {
      return this.$store.getters['cart/cartSetProducts']
    }
  }
}
</script>
